// extracted by mini-css-extract-plugin
export var section = "styles-module--section--3e4_r";
export var list = "styles-module--list--YC6oy";
export var titleStyle = "styles-module--titleStyle--38sOk";